module.exports = __webpack_public_path__ + "media/images/front/more_arrow-cba0ba41a2d8d383fd545345b4614180.png";